import React, { cloneElement, useRef } from 'react';
import useKeyboard, { KeyboardLayout } from '../../contexts/keyboard/KeyboardContext';


type Props = {
  children: React.ReactElement;
  layout?: KeyboardLayout;
  title?: string;
}

export const KeyboardWrapper = (props: Props): React.ReactElement => {
  const keyboardContext = useKeyboard()
  const inputRef = useRef<HTMLInputElement>(null)

  const onFocus = (e: MouseEvent) => {
    setTimeout(() => {
      if(inputRef.current) {
        keyboardContext.open({
          input: props.children,
          inputRef: inputRef.current,
          keyboardLayout: props.layout,
          title: props.title,
        })
      }
    }, 100)
  }

  return cloneElement(props.children, {
    onFocus,
    ref: inputRef,
  })
}
